import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FilterSection = ({ 
  selectedIndustry, 
  setSelectedIndustry, 
  selectedService, 
  setSelectedService,
  selectedSize,
  setSelectedSize,
  industries,
  services,
  businessSizes
}) => {
  const handleReset = () => {
    setSelectedIndustry('all');
    setSelectedService('all');
    setSelectedSize('all');
  };

  const hasActiveFilters = selectedIndustry !== 'all' || selectedService !== 'all' || selectedSize !== 'all';

  return (
    <div className="bg-card rounded-xl shadow-md p-4 md:p-6 lg:p-8 mb-6 md:mb-8 lg:mb-12">
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 md:gap-6 mb-4 md:mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
            <Icon name="Filter" size={20} color="#ffffff" />
          </div>
          <div>
            <h2 className="text-lg md:text-xl lg:text-2xl font-bold text-foreground font-heading">
              Filter Case Studies
            </h2>
            <p className="text-xs md:text-sm text-text-secondary">
              Find success stories relevant to your needs
            </p>
          </div>
        </div>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={handleReset}
            iconName="X"
            iconPosition="left"
          >
            Clear Filters
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        <div>
          <label className="block text-sm font-semibold text-foreground mb-2 md:mb-3">
            Industry
          </label>
          <div className="flex flex-wrap gap-2">
            {industries?.map((industry) => (
              <button
                key={industry?.value}
                onClick={() => setSelectedIndustry(industry?.value)}
                className={`px-3 md:px-4 py-2 rounded-lg text-xs md:text-sm font-medium transition-all duration-300 ${
                  selectedIndustry === industry?.value
                    ? 'bg-primary text-primary-foreground shadow-md'
                    : 'bg-muted text-foreground hover:bg-primary/10'
                }`}
              >
                {industry?.label}
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm font-semibold text-foreground mb-2 md:mb-3">
            Service Type
          </label>
          <div className="flex flex-wrap gap-2">
            {services?.map((service) => (
              <button
                key={service?.value}
                onClick={() => setSelectedService(service?.value)}
                className={`px-3 md:px-4 py-2 rounded-lg text-xs md:text-sm font-medium transition-all duration-300 ${
                  selectedService === service?.value
                    ? 'bg-primary text-primary-foreground shadow-md'
                    : 'bg-muted text-foreground hover:bg-primary/10'
                }`}
              >
                {service?.label}
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm font-semibold text-foreground mb-2 md:mb-3">
            Business Size
          </label>
          <div className="flex flex-wrap gap-2">
            {businessSizes?.map((size) => (
              <button
                key={size?.value}
                onClick={() => setSelectedSize(size?.value)}
                className={`px-3 md:px-4 py-2 rounded-lg text-xs md:text-sm font-medium transition-all duration-300 ${
                  selectedSize === size?.value
                    ? 'bg-primary text-primary-foreground shadow-md'
                    : 'bg-muted text-foreground hover:bg-primary/10'
                }`}
              >
                {size?.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSection;